<div class="modal active facility">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2 class="title">Facility Settings</h2>
      <div class="close" (click)="cancelConfiguration()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngFacilityForm" [formGroup]="form" id="FacilityForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Facility Parameters</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                    <label for="">DOC Max Range</label>
                    <input
                      maxlength="10"
                      [(ngModel)]="this.configurationController.currentConfiguration.facilityConfiguration.docMaxRange"
                      formControlName="docMaxRange"
                      type="number"
                      name="DOCMaximumRange"
                      id="DOCMaximumRange"
                      class="DOCMaximumRangeInput"
                    />
                    <span>[NM]</span>
                    <span class="error" *ngIf="form.get('docMaxRange').errors">
                       The DOC Maximum range value should be defined between 1 and 500.
                      </span>
                </div>
              </div>
              <div class="input-fields">
                <div>
                  <label for = "">DOC Max Altitude</label>
                  <div class="coordenates">
                    <input
                      maxlength="30"
                      formControlName="docMaxAltitudeFT"
                      [(ngModel)]="this.configurationController.currentConfiguration.facilityConfiguration.docMaxAltitudeFT"
                      (input)="updateFacilityField('FT','docMaxAltitude',$event.target.value)"
                      type="number"
                      name="DOCMaxAltitudeFT"
                      id="DOCMaxAltitudeFT"
                      class="DOCMaxAltitudeInput"
                    />
                    <span>[ft]</span>
                    <input
                      maxlength="30"
                      formControlName="docMaxAltitudeM"
                      [(ngModel)]="this.configurationController.currentConfiguration.facilityConfiguration.docMaxAltitudeM"
                      (input)="updateFacilityField('M','docMaxAltitude',$event.target.value)"
                      type="number"
                      name="DOCMaxAltitudeM"
                      id="DOCMaxAltitudeM"
                      class="DOCMaxAltitudeInput"
                    />
                    <span>[m]</span>
                    <span class="error" *ngIf="form.get('docMaxAltitudeFT').errors">
                      The DOC Maximum Altitude shouwld be between 0 and 60000 ft or 0 and 18288 m.
                     </span>
                  </div>
                </div>
              </div>
              <div class="input-fields">
                <div>
                  <label for = "">Antena Max Height</label>
                  <div class="coordenates">
                    <input
                      maxlength="10"
                      formControlName="antenaMaxHeightFT"
                      [(ngModel)]="this.configurationController.currentConfiguration.facilityConfiguration.antenaMaxHeightFT"
                      (input)="updateFacilityField('FT','antenaMaxHeight',$event.target.value)"
                      type="number"
                      name="AntenaMaxHeightFT"
                      id="AntenaMaxHeightFT"
                      class="AntenaMaxHeightInput"
                    />
                    <span>[ft]</span>
                    <input
                      maxlength="10"
                      formControlName="antenaMaxHeightM"
                      [(ngModel)]="this.configurationController.currentConfiguration.facilityConfiguration.antenaMaxHeightM"
                      (input)="updateFacilityField('M','antenaMaxHeight',$event.target.value)"
                      type="number"
                      name="AntenaMaxHeightM"
                      id="AntenaMaxHeightM"
                      class="AntenaMaxHeightInput"
                    />
                    <span>[m]</span>
                    <span class="error" *ngIf="form.get('antenaMaxHeightFT').errors">
                      The antenna Mast Height shouwld be between 0 and 1641 ft or 0 and 500.17682 m.
                     </span>
                  </div>
                </div>
              </div>
              <div class="input-fields">
                <div>
                  <label for = "">Above Terrain Limit</label>
                  <div class="coordenates">
                    <input
                    maxlength="10"
                    formControlName="aboveTerrainLimitFT"
                    [(ngModel)]="this.configurationController.currentConfiguration.facilityConfiguration.aboveTerrainLimitFT"
                    (input)="updateFacilityField('FT','aboveTerrainLimit',$event.target.value)"
                    type="number"
                    name="AboveTerrainLimitFT"
                    id="AboveTerrainLimitFT"
                    class="AboveTerrainLimitInput"
                  />
                  <span>[ft]</span>
                  <input
                    maxlength="10"
                    formControlName="aboveTerrainLimitM"
                    [(ngModel)]="this.configurationController.currentConfiguration.facilityConfiguration.aboveTerrainLimitM"
                    (input)="updateFacilityField('M','aboveTerrainLimit',$event.target.value)"
                    type="number"
                    name="AboveTerrainLimitM"
                    id="AboveTerrainLimitM"
                    class="AboveTerrainLimitInput"
                  />
                  <span>[m]</span>
                  </div>
                  <span class="error" *ngIf="form.get('aboveTerrainLimitM').errors">w
                    The above Terrain Limit value shouwld be between 0 and 1641 ft or 0 and 500.17682 m.
                   </span>
                </div>
              </div>

            </div>

          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="form.valid ? 'blue' : 'gray'" (click)="saveConfiguration()" [disabled]="!form.valid">
              Save
            </button>
            <button type="submit" [ngClass]="form.valid ? 'blue' : 'gray'" (click)="retoreDefaults();">
              Restore Defaults
            </button>
            <button class="gray" (click)="cancelConfiguration()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
